module.exports = __webpack_public_path__ + "media/images/bnr_header_newplan_80off_pc-c92814146e9db36d6dc77f7776829759.jpg";